<!-- www.quickepay / ApiStatus
Edited with WebStorm
Created by maizerg on 2/20/18 at 2:15 PM
<!-->

<template>
    <div>
        Send view
    </div>
</template>

<script>
export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/developers/ApiStatus.vue